import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientListLayer from "../components/ClientListLayer";

const ClientListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        <ClientListLayer />
      </MasterLayout>
    </>
  );
};

export default ClientListPage;
